module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_7.bdf72cc5.jpg";